import { Database } from "@/integrations/supabase/types";

export type ConsentLog = Database["public"]["Tables"]["consent_logs"]["Row"];

export function getConsentGroupKey(log: ConsentLog): string {
  const timestampMs = log.timestamp ? new Date(log.timestamp).getTime() : NaN;
  const minuteBucket = Number.isFinite(timestampMs)
    ? Math.floor(timestampMs / 60000).toString()
    : log.timestamp || "";

  return [
    log.email || "",
    minuteBucket,
    log.source_form || "",
    log.ip_address || "",
    log.user_agent || "",
  ].join("|");
}
